import { LoadStatus } from '@rematter/frontend-lib-api-client';
import { ThemeColors } from '@rematter/ui-web';
import { Badge } from '@rematter/ui-web';

import { FullLoadRecord } from '../../_graphql/queryLoadDetails';

export type LoadHeaderBadgesProps = { load?: FullLoadRecord };

const getStatusColor = (status: LoadStatus, reviewed: boolean) => {
  const effectiveStatus = reviewed ? 'Reviewed' : status;

  switch (effectiveStatus) {
    case 'Unassigned':
      return ThemeColors.neutral;
    case 'Pending':
      return ThemeColors.warning;
    case 'Voided':
      return ThemeColors.failure;
    case 'Shipped':
      return ThemeColors.warning;
    case 'Received':
      return ThemeColors.primary;
    case 'Reconciled':
      return ThemeColors.success;
    case 'Reviewed':
      return ThemeColors.success;
  }
};

type LoadStatusBadgeProps = {
  status: LoadStatus;
  reviewed: boolean;
};

export const LoadStatusBadge = ({ status, reviewed }: LoadStatusBadgeProps) => (
  <Badge color={getStatusColor(status, reviewed)} className="@LoadStatusBadge">
    {status}
  </Badge>
);

export type LoadBookingNumberBadgeProps = { bookingNumber: string };

export const LoadBookingBadge = ({
  bookingNumber,
}: LoadBookingNumberBadgeProps) => (
  <Badge color={'success'} className="@LoadBookingBadge">
    BK #{bookingNumber}
  </Badge>
);

type LoadPurchaseOrderBadgeProps = { purchaseOrderNumber: string };

export const LoadPurchaseOrderBadge = ({
  purchaseOrderNumber,
}: LoadPurchaseOrderBadgeProps) => (
  <Badge size="small" color={'primary'} className="@LoadPurchaseOrderBadge">
    PO #{purchaseOrderNumber}
  </Badge>
);
